import { render, staticRenderFns } from "./manualDeposit.vue?vue&type=template&id=85620df2&scoped=true&lang=pug"
import script from "./manualDeposit.vue?vue&type=script&lang=js"
export * from "./manualDeposit.vue?vue&type=script&lang=js"
import style0 from "./manualDeposit.vue?vue&type=style&index=0&id=85620df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85620df2",
  null
  
)

export default component.exports